import { api } from '../createApi';
import { TagType } from '../TagType';

const TAG_BY_LIST = { type: TagType.DashboardV2, id: 'LIST' };
const TAG_BY_ID = { type: TagType.DashboardV2, id: 'ID' };

api.enhanceEndpoints({
  addTagTypes: [TagType.DashboardV2 as TagType],
  endpoints: {
    getDashboardsV2: {
      providesTags: [TAG_BY_LIST],
    },
    getDashboardV2: {
      providesTags: [TAG_BY_ID],
    },
    saveAsDashboard: {
      invalidatesTags: [TAG_BY_LIST, TAG_BY_ID],
    },
    saveDashboardChanges: {
      invalidatesTags: [TAG_BY_LIST, TAG_BY_ID],
    },
    updateDashboard: {
      invalidatesTags: [TAG_BY_LIST, TAG_BY_ID],
    },
    deleteDashboard: {
      invalidatesTags: [TAG_BY_LIST, TAG_BY_ID],
    },
  },
});
